import { StatisticItem } from './types'

import MarkerIcon from 'assets/img/promo-page/markerIcon.webp'
import ZipIcon from 'assets/img/promo-page/zipIcon.webp'

export const statisticsData: StatisticItem[] = [
  {
    id: 1,
    value: '72 000',
    description: 'пунктов выдачи заказов',
    IconLink: MarkerIcon,
  },
  {
    id: 2,
    value: '4 трлн ₽',
    description: 'годовой оборот компании',
  },
  {
    id: 3,
    value: '4,5 млрд',
    description: 'заказов в год',
  },
  {
    id: 4,
    value: '2–6 месяцев',
    description: 'средний срок, за который окупается ПВЗ',
    IconLink: ZipIcon,
  },
]
